import React from 'react';
import moment from 'moment';
import styled from 'styled-components';

import Snapshots from './Snapshot/Snapshots';
import Models from './Model/Models';
import ReportHeader from './ReportHeader';
import Spacer from './Spacer';
import Frame from './../Wrappers/Frame';
import StatisticsService from '../../services/StatisticsService';
import { report } from '../../services/api';
import './MonthlyResult.css';

const Container = styled.div`
  width: 86%;
  margin-left: 7%;
`;

interface Props {
  id: string;
}

interface State {
  data: Report | null;
}

class MainReport extends React.Component<Props, State> {
  state: State = {
    data: null,
  };

  constructor(props: Props) {
    super(props);
    report.static(props.id).then((data) => {
      if (data.data.report.type === 'group') {
        const models = StatisticsService.filterUniqueById<Model>(data.data.locations, 'models');
        const posts = StatisticsService.filterUniqueById<ReportPost>(data.data.locations, 'posts');
        this.setState({
          data: {
            ...data.data,
            models,
            posts: posts,
            views: StatisticsService.views(models, posts),
          },
        });
      } else {
        this.setState({
          data: {
            ...data.data,
            views: StatisticsService.views(data.data.models, data.data.posts),
          },
        });
      }
    });
  }

  render() {
    const data = this.state.data;

    if (data !== null) {
      if (data.error) {
        return (
          <div className="alert alert-danger result-error" role="alert">
            <div className="pdf-render" />
            <h4 className="alert-heading">{data.error}</h4>
          </div>
        );
      }
      if (!data.report) return null;
      let range = '';
      if (data.report.type === 'offer') {
        const from = moment.parseZone(data.report.date_from),
          to = moment.parseZone(data.report.date_to);
        if (from.isSame(to, 'date')) range = from.format('MMM D, YYYY');
        else if (from.isSame(to, 'year'))
          range = `${from.format('MMM D')} - ${to.format('MMM D')}, ${from.format('YYYY')}`;
        else range = `${from.format('MMM D YYYY')} - ${to.format('MMM D YYYY')}`;
      } else {
        range = `${data.report.date_from} - ${data.report.date_to}`;
      }

      const big = data.models.length > 200 || data.posts.length > 400;

      return (
        <div>
          <Container>
            <Frame title="Results" style={{ width: '50%' }} hidePrint={true}>
              <ReportHeader big={big} report={data.report} range={range} />
              <div className="pdf-render" />
              <Spacer />
              <Models
                models={data.models}
                views={data.views}
                showInPerson={data.report.show_in_person}
              />
              <Spacer />
              <Snapshots
                posts={data.posts}
                organicCampaigns={data.organic}
                showComments={data.report.show_comments}
                views={data.views}
                showInPerson={data.report.show_in_person}
              />
            </Frame>
          </Container>
        </div>
      );
    } else {
      return null;
    }
  }
}
export default MainReport;
